var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass:
        "pressa-banner position-relative overflow-hidden rounded-sm pa-6 border",
    },
    [
      _c("span", { staticClass: "banner-overlay-darken" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column position-relative bg-gray-0--text" },
        [
          _c("p", { staticClass: "text-body-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "«Лучшая в мире система клиентского сервиса является и самой простой: делай то, что обещал, и делай это с первого раза.»",
                    _setup.options
                  )
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-right text-body-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("— Карл Сьюэлл", _setup.options)) +
                "\n    "
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }